import { AvailabilityIndicator, CropAndBrandAvailability7, HybridAvailability7, Packaging } from '../../../../logic/Models/Responses/SeedResponseV7';
import { CropConfig, ICropConfig } from '../../../../logic/store/Seeds/CropsSlice';


export interface IPackagingAvailability
{
	PackageType: Packaging;
	Availability: AvailabilityIndicator;
}

export interface ISelectableTreatment
{
	Selected: boolean;
	IsDeleted: boolean;
	TreatmentId: string;
	Name: string;
	Availability: AvailabilityIndicator;
	PackagingAvailability: IPackagingAvailability[];
}

export const calculateTotalBags = (quantityQB: number, quantityPB: number, quantityTB: number, quantityTO: number, cropId: string): number =>
{
	const cropConfig: ICropConfig = CropConfig()[cropId];
	const { bagsPerToteBag, cubitsPerBag } = cropConfig;

	const paperBags = quantityPB ?? 0;
	const cubitsAsBags = (quantityQB ?? 0) * cubitsPerBag;
	const toteBagsAsBags = (quantityTO ?? 0) * (bagsPerToteBag ?? 1);
	const trubulkAsBags = quantityTB ?? 0;
	const totalBags = paperBags + cubitsAsBags + toteBagsAsBags + trubulkAsBags;

	return totalBags;
};

export const setupTreatments = (hybrid: HybridAvailability7) : ISelectableTreatment[] =>
{
	const selectableTreatments: ISelectableTreatment[] = [];

	for(const treatment of Object.values(hybrid.Treatments))
	{
		selectableTreatments.push({
			Selected: false,
			IsDeleted: false, // TODO : Update the API to include this information
			Name: treatment.TreatmentName,
			TreatmentId: treatment.TreatmentId,
			Availability: treatment.Availability,
			PackagingAvailability: treatment.MaterialAvailability.map(pa => ({
				PackageType: pa.Packaging,
				Availability: pa.Availability
			}))
		});
	}

	return selectableTreatments;
};

export function FlattenHybridAvailability(Seeds: CropAndBrandAvailability7[]) 
{
	return Seeds.flatMap(ba => Object.values(ba.Series)
		.flatMap(s => Object.values(s.Hybrids)
			.map(h => ({ ...h, BrandName: ba.Brand, CropId: ba.CropId, RelativeMaturity: s.RelativeMaturity }))));
}
